export function routes($stateProvider) {
    $stateProvider
        .state('app.administration.lists', {
        url: '/listas',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.administration.lists.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<list-relatorio></list-relatorio>',
        role: ['listasRelatorios'],
        title: 'Listagem de listas de relatório',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.administration.lists.view', {
        url: '/{id:int}',
        template: '<details-relatorio></details-relatorio>',
        title: 'Detalhes de lista de relatório',
        role: ['listasRelatorios'],
        params: {
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.lists.view-parametro', {
        url: '/{lista:int}/parametro/{id: int}',
        template: '<details-relatorio-parametro></details-relatorio-parametro>',
        title: 'Detalhes de paramêtros de lista',
        role: ['listasRelatorios'],
        params: {
            lista: {
                dynamic: true
            },
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.lists.view-ensaio', {
        url: '/{lista:int}/ensaio/{id: int}',
        template: '<details-relatorio-ensaio></details-relatorio-ensaio>',
        title: 'Detalhes de ensaios de lista',
        role: ['listasRelatorios'],
        params: {
            lista: {
                dynamic: true
            },
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.lists.view-equipamento', {
        url: '/{lista:int}/equipamento/{id: int}',
        template: '<details-relatorio-equipamento></details-relatorio-equipamento>',
        title: 'Detalhes de equipamentos de lista',
        role: ['listasRelatorios'],
        params: {
            lista: {
                dynamic: true
            },
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.clausulas', {
        url: '/listas/clausulas',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.administration.clausulas.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<list-clausulas></list-clausulas>',
        title: 'Listagem de cláusulas e defeitos',
        role: ['listasDefeitos'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.administration.clausulas.view', {
        url: '/{id:int}',
        template: '<details-clausula></details-clausula>',
        title: 'Detalhes de lista de cláusulas',
        role: ['listasDefeitos'],
        params: {
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.relatorios', {
        url: '/listas/relatorios',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.administration.relatorios.edit', {
        url: '/edit/{id:int}',
        template: '<edit-relatorio></edit-relatorio>',
        title: 'Edição de Relatório',
        params: {
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.resultados', {
        url: '/listas/resultados',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.administration.resultados.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<list-resultados></list-resultados>',
        title: 'Listagem de resultados',
        role: ['listasRelatorios'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.administration.resultados.view', {
        url: '/{id:int}',
        template: '<details-clausula></details-clausula>',
        title: 'Detalhes de resultados',
        role: ['listasRelatorios'],
        params: {
            id: {
                dynamic: true
            }
        }
    })
        .state('app.administration.normas', {
        url: '/listas/normas',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.administration.normas.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<list-normas></list-normas>',
        title: 'Listagem de Procedimentos',
        role: ['listasNormas'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.administration.normas.view', {
        url: '/{id:int}',
        template: '<details-clausula></details-clausula>',
        title: 'Detalhes de lista de cláusulas',
        role: ['listasNormas'],
        params: {
            id: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
